// extracted by extract-css-chunks-webpack-plugin
module.exports = {"app-menu":"_13R0K","appMenu":"_13R0K","item-group":"_3G1S4","itemGroup":"_3G1S4","active":"_2WOwZ","menu-item":"_3Nbgv","menuItem":"_3Nbgv","sub":"_1JyFw"};